export const CLIENT_REF_ID = process.env.REACT_APP_CLIENT_REF_ID;
export const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
export const BFF_API_BASE_URL = process.env.REACT_APP_BFF_API_BASE_URL;
